import { render, staticRenderFns } from "./ArticleWhole.vue?vue&type=template&id=818bd898&scoped=true&"
import script from "./ArticleWhole.vue?vue&type=script&lang=js&"
export * from "./ArticleWhole.vue?vue&type=script&lang=js&"
import style0 from "./ArticleWhole.vue?vue&type=style&index=0&id=818bd898&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818bd898",
  null
  
)

export default component.exports